// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"382":"ea37f221","453":"f2cee86e","517":"ffdfd7c7"}[chunkId] + ".chunk.js";
};